export default __webpack_public_path__ + "static/covid-e19342302a7aa46fd3221618790223bf.jpeg";